import { LogoWithText } from '@insify/design-system/logo';
import { TrackedDiv } from '@objectiv/tracker-react';

import { ContactOptions } from '../ContactOptions';
import { Indicator } from '../Indicator';

import * as styles from './Sidebar.module.css';

import type { ContactOptionsProps } from '../ContactOptions';
import type { IndicatorProps } from '../Indicator';
import type React from 'react';

type Image = {
  url: string;
  title: string;
};

export type GenericSidebarProps = {
  content: React.ReactNode;
  logo?: React.ReactNode;
  background?: Image;
  logoHref?: string;
  logoTarget?: string;
};

export const GenericSidebar = ({ logo, logoHref, content, logoTarget }: GenericSidebarProps) => {
  return (
    <TrackedDiv objectiv={{ id: 'sidebar' }} className={styles.container}>
      <a href={logoHref} target={logoTarget}>
        {logo ? logo : <LogoWithText className={styles.logo} />}
      </a>
      {content}
    </TrackedDiv>
  );
};

export type SidebarProps<Step extends string> = Omit<GenericSidebarProps, 'content'> &
  Omit<IndicatorProps<Step>, 'className'> &
  Omit<ContactOptionsProps, 'className'>;

export const Sidebar = <Step extends string>({
  currentStep,
  steps,
  stepsGroups,
  contactOptions,
  contactOptionsTitle,
  contactOptionsDescription,
  ...props
}: SidebarProps<Step>) => {
  return (
    <GenericSidebar
      content={
        <>
          <Indicator<Step>
            className={styles.indicator}
            currentStep={currentStep}
            steps={steps}
            stepsGroups={stepsGroups}
          />
          <ContactOptions
            contactOptions={contactOptions}
            contactOptionsTitle={contactOptionsTitle}
            contactOptionsDescription={contactOptionsDescription}
            className={styles.contactOptions}
          />
        </>
      }
      {...props}
    />
  );
};
